import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {applicationService} from "../../services/application.service";

const initialState = {
    cleanerApplicationsByCurrentCleaner: [],
    cleanerApplicationsByCleaningRequest: [],
    status: '',
    totalItems: null,
}

const getAllByCurrentCleaner = createAsyncThunk(
    'cleanerApplicationsSlice/getAllByCurrentCleaner',
    async ({page}) => {
        try {
            const {data} = await applicationService.getAllByCurrentUser(page);

            return data;
        } catch (error) {
            throw error;
        }
    }
);


const getFilteredByCleanerRequest = createAsyncThunk(
    'cleanerApplicationsSlice/getFilteredByCleanerRequest',
    async ({id, params}) => {
        try {
            const {data} = await applicationService.getFilteredByRequest(id, params);

            return data;
        } catch (error) {
            throw error;
        }
    }
);

const cleanerApplicationsSlice = createSlice({
    name: 'cleanerApplicationsSlice',
    initialState,
    reducers: {},
    extraReducers: builder => builder
        .addCase(getAllByCurrentCleaner.fulfilled, (state, action) => {
            const {count, results} = action.payload;
            state.cleanerApplicationsByCurrentCleaner = results;
            state.totalItems = count;

            state.status = 'success'
        })
        .addCase(getAllByCurrentCleaner.pending, (state, action) => {
            state.status = 'loading'
        })

        .addCase(getFilteredByCleanerRequest.fulfilled, (state, action) => {
            const {count, results} = action.payload;
            state.cleanerApplicationsByCleaningRequest = results;
            state.totalItems = count;

            state.status = 'success'
        })
        .addCase(getFilteredByCleanerRequest.pending, (state, action) => {
            state.status = 'loading'
        })
});

const {actions, reducer: cleanerApplicationsReducer} = cleanerApplicationsSlice;

const cleanerApplicationsActions = {
    ...actions,
    getAllByCurrentCleaner,
    getFilteredByCleanerRequest,
}

export {
    cleanerApplicationsActions,
    cleanerApplicationsReducer,
}
